
import Table from './Table';
import ActivityCard from '../../../../Core/Activity/ActivityCard';
import Checkbox from '../../../../Core/Fields/Floating/Checkbox';
const Tab2 = ({ setSelectedCompanyAccounts, apidata, isyca, setyca, companyAccounts,addressId,formdata,onInputChange }) => {
    // console.log('c:',apidata.is_your_company_address);
    return (
      <div>
            <div className="px-3" style={{ background: 'white' }}>
              
                <div className="mb-3" >

                    <div className="col-md-12 px-2" style={{ display: 'flex', gap: '20px' }} >
                        <div className='' style={{ height: "100%", borderRadius: '4px', display: 'flex', flexDirection: 'column', width: '100%', padding: '10px', border: '1px solid #DBDBDB', borderRadius: '5px' }}>
                            <div style={{ display: 'flex', gap: '15px' }}>
                                <div style={{ flex: 1 }}>
                                    <p className='' style={{ fontSize: '16px', fontWeight: '600' }}>Reference</p>
                                </div>
                            </div>
 <div className="mb-1" style={{ display: 'flex', gap: '15px' }}>
                               <div style={{ flex: 1 }}>

<Checkbox
                                             id="IsYourCompanyAddress"
                                            label="Is Your Company Address"
                                             checked={true}
                                             value={formdata.isyca || 0}
                                             onChange={(checked) => onInputChange("isyca", checked)}
                                         />

</div>

                                </div>
                          <Table
                    setSelectedCompanyAccounts={setSelectedCompanyAccounts} apidata={apidata} companyAccounts={companyAccounts}
                />





                        </div>
                    </div>

                </div>
              <div className="mb-3" style={{ display: 'flex', gap: '20px' }} >

          <div className="col-md-12">
            <div className='' style={{ height: "100%", borderRadius: '4px', display: 'flex', flexDirection: 'column', width: '100%', padding: '10px' }}>
             <ActivityCard doctype="Address" docname={addressId} />
            </div>
          </div>
        </div>
            </div>

        </div >
    )
}

export default Tab2